import(/* webpackMode: "eager" */ "/Users/salasardeveloper/Documents/ashlok_web/ashlok_seo/src/app/product/page.js");
